import React from 'react';
import { Box, Typography } from '@mui/material';

// ── 32 Cards — Dono images ka path yahan daalo ──────────────────────────────
import card32Table from '../../images/32cards.png';   // Image 1: Cards Deck table
import card32Rules from '../../images/32cards1.png';  // Image 2: Game rules & player table

// ── Teen Patti T20 ───────────────────────────────────────────────────────────
import t20 from '../../images/T20.png';
import cardteen from '../../images/2cardtenn.png';
import cardteen1 from '../../images/2cardteen1.png';
// ─────────────────────────────────────────────────────────────────────────────

export const GAME_RULES = {

    'Andar Bahar': `Andar Bahar is a very simple game that involves the use of a single pack of cards. Game is played between the House and the Player. The dealer deals a single card face up on the Joker place and then proceeds to deal cards face up on A (ANDAR) and B (BAHAR) spots. When a card appears that matches the value of the Joker card then the game ends. Before the start of the game, players bet on which side they think the game will end.`,

    'Dragon Tiger': (
        <Box>
            <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121', mb: 1 }}>
                {'• In the Dragon Tiger game two hands are dealt; one for the Dragon and another for the Tiger. The player bets which will win.'}
            </Typography>
            <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121', mb: 1 }}>
                {'• The winning hand is the hand with the highest ranking card. There are ranking of suits in the game of Dragon Tiger. The game is played with single deck.'}
            </Typography>
            <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121', mb: 1 }}>
                {'• The ranking of cards is, from lowest to highest: Ace, 2, 3, 4, 5, 6, 7, 8, 9, 10, Jack, Queen and King when Ace is "1" and King is "13".'}
            </Typography>
            <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121', mb: 1 }}>
                {'• On same card with different suit, Winner will be declared based on below winning suit sequence.'}
            </Typography>
            {[
                { suit: '♠', label: '1st – Spade',   color: '#000' },
                { suit: '♥', label: '2nd – Heart',   color: '#e53935' },
                { suit: '♣', label: '3rd – Club',    color: '#000' },
                { suit: '♦', label: '4th – Diamond', color: '#e53935' },
            ].map(({ suit, label, color }) => (
                <Box key={label} sx={{ display: 'flex', alignItems: 'center', gap: '10px', mb: '8px' }}>
                    <Box
                        sx={{
                            width: '28px',
                            height: '39px',
                            borderRadius: '4px',
                            background: 'linear-gradient(144.15deg, #F2F2F2 2.66%, #D9D9D9 97.34%)',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                            boxShadow: '0 1px 3px rgba(0,0,0,0.15)',
                        }}
                    >
                        <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#212121', lineHeight: 1 }}>A</Typography>
                        <Typography sx={{ fontSize: '18px', color, lineHeight: 1, mt: '2px' }}>{suit}</Typography>
                    </Box>
                    <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '13px', color: '#212121' }}>
                        {label}
                    </Typography>
                </Box>
            ))}
        </Box>
    ),

    'Roulete': `The objective in Roulette is to predict the number on which the ball will land by placing one or more bets that cover that particular number. The wheel in European Roulette includes the numbers 1-36 plus a single 0 (zero). After betting time has expired, the ball is spun within the Roulette wheel. The ball will eventually come to rest in one of the numbered pockets within the wheel. You win if you have placed a bet that covers that particular number.

BET TYPES:
Bets made on the numbered spaces on the betting area, or on the lines between them, are called Inside Bets, while bets made on the special boxes below and to the side of the main grid of numbers are called Outside Bets.

INSIDE BETS:
Straight Up — place your chip directly on any single number (including zero).
Split Bet — place your chip on the line between any two numbers, either on the vertical or horizontal.
Street Bet — place your chip at the end of any row of numbers. A Street Bet covers three numbers.
Corner Bet — place your chip at the corner (central intersection) where four numbers meet. All four numbers are covered.
Line Bet — place your chip at the end of two rows on the intersection between the two rows. A Line Bet covers all the numbers in both rows, a total of six numbers.

OUTSIDE BETS:
Column Bet — place your chip in one of the boxes marked "2 to 1" at the end of the column that covers all 12 numbers in that column. The zero is not covered by any column bet.
Dozen Bet — place your chip in one of the three boxes marked "1st 12," "2nd 12" or "3rd 12" to cover the 12 numbers alongside the box.
Red/Black — place your chip in the Red or Black box to cover the 18 red or 18 black numbers. The zero is not covered by these bets.
Even/Odd — place your chip in one of these boxes to cover the 18 even or 18 odd numbers. The zero is not covered by these bets.
1-18/19-36 — place your chip in either of these boxes to cover the first or second set of 18 numbers. The zero is not covered by these bets.

PLACE YOUR BETS:
The CHIP DISPLAY allows you to select the value of each chip you wish to bet. Only chips of denominations that can be covered by your current balance will be enabled.
• Remove — removes all your bets from the table.
• Rebet — repeats all bets from the previous game round (available only before the first chip is placed).
• Undo — removes the last bet you placed.
• Double — doubles your current round bets on each click (enabled only after the first stake is placed).

NOTE: Please do not minimise your browser or open any other tab while betting time remains and you have placed bets on the table. Such actions may be interpreted as leaving the game, and your bets will be declined for that particular round.`,

       'Teen Patti T20': (
        <Box>
            {/* ── Text above image ── */}
            {[
                '• The game is played with a regular 52 cards single deck, between 2 players A and B.',
                '• Each player will receive 3 cards.',
                '• In case of tie comes result will be declared on basis of suit rank of high card.',
                '• Rules of regular teenpatti winner',
            ].map((text, i) => (
                <Typography key={i} sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: i === 3 ? 700 : 600, fontSize: '12px', lineHeight: 1.6, color: '#212121', mb: '4px' }}>
                    {text}
                </Typography>
            ))}
 
            {/* ── Image ── */}
            <img
                src={t20}
                alt="Teen Patti T20 Rules"
                style={{ width: '304px', display: 'block', marginTop: '3px',height:'476px' }}
            />
        </Box>
    ),

    'Lucky 7': (
    <Box>
        {/* ── Bullet Points ── */}
        {[
            'Lucky 7 is a 8 deck playing cards game, total 8 * 52 = 416 cards.',
            'If the card is from ACE to 6, LOW Wins.',
            'If the card is from 8 to KING, HIGH Wins.',
            'If the card is 7, bets on high and low will lose 50% of the bet amount.',
        ].map((text, i) => (
            <Box key={i} sx={{ display: 'flex', alignItems: 'flex-start', gap: '6px', mb: '4px' }}>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', color: '#212121', lineHeight: 1.6 }}>•</Typography>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121' }}>{text}</Typography>
            </Box>
        ))}

        {/* ── Payout Box ── */}
        <Box sx={{ border: '1px solid #4FC3F7', p: '10px', mt: '3px' }}>
            {[
                { label: 'LOW', labelExtra: ' | HIGH', desc: '1,2,3,4,5,6 | HIGH: 8,9,10,J,Q,K', payout: '2.0' },
                { label: 'EVEN', desc: '2,4,6,8,10,Q', payout: '2.10' },
                { label: 'ODD', desc: '1,3,5,7,9,J,K', payout: '1.79' },
                { label: 'RED', desc: null, payout: '1.95' },
                { label: 'BLACK', desc: null, payout: '1.95' },
                { label: 'CARDS', desc: '1,2,3,4,5,6,7,8,9,10,J,Q,K', payout: '12.0', payoutLabel: 'PAYOUT' },
            ].map(({ label, desc, payout, payoutLabel }, i) => (
                <Box key={i} sx={{ mb: '12px' }}>
                    <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontSize: '12px', fontWeight: 600, color: '#212121', lineHeight: 1.6 }}>
                        <span style={{ color: '#118AB2', fontWeight: 700 }}>{label}: </span>
                        {desc}
                    </Typography>
                    <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', color: '#212121', lineHeight: 1.6 }}>
                        {payoutLabel ? `PAYOUT: ${payout}` : `Payout:${payout}`}
                    </Typography>
                </Box>
            ))}
        </Box>
    </Box>
),

   'Baccarat': (
    <Box>
        {/* ── Rules of 3 Baccarat ── */}
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: '13px', color: '#212121', mb: '6px' }}>
            Rules of 3 baccarat
        </Typography>
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121', mb: '6px' }}>
            There are 3 criteria for winning the 3 Baccarat.
        </Typography>

        {/* First Criteria */}
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: '12px', color: '#212121', mb: '4px' }}>
            First criteria:
        </Typography>
        {[
            'Game having trio will win,',
            'If both game has trio then higher trio will win.',
            'Ranking of trio from high to low.',
            '1,1,1', 'K,K,K', 'Q,Q,Q', 'J,J,J', '10,10,10', '9,9,9', '8,8,8',
            '7,7,7', '6,6,6', '5,5,5', '4,4,4', '3,3,3', '2,2,2',
            'If none of the game have got trio then second criteria will apply.',
        ].map((text, i) => (
            <Box key={i} sx={{ display: 'flex', alignItems: 'flex-start', gap: '6px', mb: '2px' }}>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', color: '#212121', lineHeight: 1.6 }}>•</Typography>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121' }}>{text}</Typography>
            </Box>
        ))}

        {/* Second Criteria */}
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: '12px', color: '#212121', mt: '10px', mb: '4px' }}>
            Second criteria:
        </Typography>
        {[
            'Game having all the three face card will win.',
            'Here JACK, QUEEN AND KING are named face card.',
            'if both the game have all three face cards then game having highest face card will win.',
            'Ranking of face card from High to low :',
            'Spade King', 'Heart King', 'Club King', 'Diamond King',
            'Same order will apply for Queen (Q) and Jack (J) also.',
            'If second criteria is also not applicable, then 3rd criteria will apply.',
        ].map((text, i) => (
            <Box key={i} sx={{ display: 'flex', alignItems: 'flex-start', gap: '6px', mb: '2px' }}>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', color: '#212121', lineHeight: 1.6 }}>•</Typography>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121' }}>{text}</Typography>
            </Box>
        ))}

        {/* 3rd Criteria */}
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: '12px', color: '#212121', mt: '10px', mb: '4px' }}>
            3rd criteria:
        </Typography>
        {[
            'Game having higher baccarat value will win.',
            'For deciding baccarat value we will add point value of all the three cards',
            'Point value of all the cards :',
            '1 = 1', '2 = 2', 'To', '9 = 9',
            '10, J ,Q, K has zero (0) point value.',
        ].map((text, i) => (
            <Box key={i} sx={{ display: 'flex', alignItems: 'flex-start', gap: '6px', mb: '2px' }}>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', color: '#212121', lineHeight: 1.6 }}>•</Typography>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121' }}>{text}</Typography>
            </Box>
        ))}

        {/* Example 1st */}
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: '12px', color: '#212121', mt: '10px', mb: '4px' }}>
            Example 1st:
        </Typography>
        {[
            'Last digit of total will be considered as baccarat value',
            '2,5,8 =',
            '2+5+8 =15 here last digit of total is 5 , So baccarat value is 5.',
        ].map((text, i) => (
            <Box key={i} sx={{ display: 'flex', alignItems: 'flex-start', gap: '6px', mb: '2px' }}>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', color: '#212121', lineHeight: 1.6 }}>•</Typography>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121' }}>{text}</Typography>
            </Box>
        ))}

        {/* Example 2nd */}
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: '12px', color: '#212121', mt: '10px', mb: '4px' }}>
            Example 2nd :
        </Typography>
        {[
            '1,3,K',
            '1+3+0 = 4 here total is in single digit so we will take this single digit 4 as baccarat value',
        ].map((text, i) => (
            <Box key={i} sx={{ display: 'flex', alignItems: 'flex-start', gap: '6px', mb: '2px' }}>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', color: '#212121', lineHeight: 1.6 }}>•</Typography>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121' }}>{text}</Typography>
            </Box>
        ))}
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121', mt: '6px', mb: '4px' }}>
            If baccarat value of both the game is equal then Following condition will apply :
        </Typography>

        {/* Condition 1 */}
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: '12px', color: '#212121', mt: '6px', mb: '4px' }}>
            Condition 1 :
        </Typography>
        {[
            'Game having more face card will win.',
            'Example : Game A has 3,4,k and B has 7,J,Q then game B will win as it has more face card then game A.',
        ].map((text, i) => (
            <Box key={i} sx={{ display: 'flex', alignItems: 'flex-start', gap: '6px', mb: '2px' }}>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', color: '#212121', lineHeight: 1.6 }}>•</Typography>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121' }}>{text}</Typography>
            </Box>
        ))}

        {/* Condition 2 */}
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: '12px', color: '#212121', mt: '6px', mb: '4px' }}>
            Condition 2 :
        </Typography>
        {[
            'If Number of face card of both the game are equal then higher value face card game will win.',
            'Example : Game A has 4,5,K (K Spade) and Game B has 9,10,K (K Heart) here baccarat value of both the game is equal (9) and both the game have same number of face card so game A will win because It has got higher value face card then Game B.',
        ].map((text, i) => (
            <Box key={i} sx={{ display: 'flex', alignItems: 'flex-start', gap: '6px', mb: '2px' }}>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', color: '#212121', lineHeight: 1.6 }}>•</Typography>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121' }}>{text}</Typography>
            </Box>
        ))}

        {/* Condition 3 */}
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: '12px', color: '#212121', mt: '6px', mb: '4px' }}>
            Condition 3 :
        </Typography>
        {[
            'If baccarat value of both the game is equal and none of game has got face card then in this case Game having highest value point card will win.',
        ].map((text, i) => (
            <Box key={i} sx={{ display: 'flex', alignItems: 'flex-start', gap: '6px', mb: '2px' }}>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', color: '#212121', lineHeight: 1.6 }}>•</Typography>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121' }}>{text}</Typography>
            </Box>
        ))}

        {/* Value of Point Cards */}
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: '12px', color: '#212121', mt: '8px', mb: '4px' }}>
            Value of Point Cards :
        </Typography>
        {[
            'Ace = 1', '2 = 2', '3 = 3', '4 = 4', '5 = 5',
            '6 = 6', '7 = 7', '8 = 8', '9 = 9', '10 = 0 (Zero)',
            'Example : GameA: 1,6,10 And GameB: 7,10,10',
            'here both the game have same baccarat value . But game B will win as it has higher value point card i.e. 7.',
        ].map((text, i) => (
            <Box key={i} sx={{ display: 'flex', alignItems: 'flex-start', gap: '6px', mb: '2px' }}>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', color: '#212121', lineHeight: 1.6 }}>•</Typography>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121' }}>{text}</Typography>
            </Box>
        ))}

        {/* Condition 4 */}
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: '12px', color: '#212121', mt: '6px', mb: '4px' }}>
            Condition 4 :
        </Typography>
        {[
            'If baccarat value of both game is equal and none of game has got face card and high point card of both the game is of equal point value , then suits of both high card will be compared',
            'Example :',
            'Game A : 1(Heart) ,2(Heart) ,5(Heart)',
            'Game B : 10 (Heart) , 3 (Diamond ) , 5 (Spade )',
            'Here Baccarat value of both the game (8) is equal . and none of game has got face card and point value of both game\'s high card is equal so by comparing suits of both the high card ( A 5 of Heart , B 5 of spade ) game B is declared 3 Baccarat winner.',
            'Ranking of suits from High to low :',
            'Spade', 'Heart', 'Club', 'Diamond',
        ].map((text, i) => (
            <Box key={i} sx={{ display: 'flex', alignItems: 'flex-start', gap: '6px', mb: '2px' }}>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', color: '#212121', lineHeight: 1.6 }}>•</Typography>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121' }}>{text}</Typography>
            </Box>
        ))}

        {/* Rules of Total */}
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: '13px', color: '#212121', mt: '12px', mb: '4px' }}>
            Rules of Total :
        </Typography>
        {[
            'It is a comparison of total of all three cards of both the games.',
            'Point value of all the cards for the bet of total',
            'Ace = 1', '2 = 2', '3 = 3', '4 = 4', '5 = 5', '6 = 6',
            '7 = 7', '8 = 8', '9 = 9', '10 = 10', 'Jack = 11', 'Queen = 12', 'King = 13',
            'suits doesn\'t matter',
            'If total of both the game is equal , it is a Tie.',
            'If total of both the game is equal then half of your bet amount will returned.',
        ].map((text, i) => (
            <Box key={i} sx={{ display: 'flex', alignItems: 'flex-start', gap: '6px', mb: '2px' }}>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', color: '#212121', lineHeight: 1.6 }}>•</Typography>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121' }}>{text}</Typography>
            </Box>
        ))}

        {/* Rules of Pair Plus */}
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: '13px', color: '#212121', mt: '12px', mb: '4px' }}>
            Rules of Pair Plus :
        </Typography>
        {[
            'This bet provides multiple option to win a price.',
            'Option 1 : Pair',
            'If you got pair you will get equal value return of your betting amount.',
            'Option 2 : Flush',
            'If you have all three cards of same suits you will get 4 times return of your betting amount.',
            'Option 3 : Straight',
            'If you have straight ( three cards in sequence eg : 4,5,6 eg: J,Q,K ) (but king ,Ace ,2 is not a straight ) you will get six times return of your betting amount.',
            'Option 4 : Straight Flush',
            'If you have straight of all three cards of same suits ( Three cards in sequence eg: 4,5,6 ) ( but King ,Ace ,2 is not straight ) you will get 30 times return of your betting amount.',
            'If you have straight flush you will receive price of straight flush only , In this case you will not receive price of straigh and flush.',
            'It means you will receive only one price whichever is higher.',
            'Option 5 : Trio',
            'If you have got all the cards of same rank ( eg: 4,4,4 J,J,J ) you will get 40 times return of your betting amount.',
            'Note : If you have trio then you will receive price of trio only , In this case you will not receive price of pair.',
        ].map((text, i) => (
            <Box key={i} sx={{ display: 'flex', alignItems: 'flex-start', gap: '6px', mb: '2px' }}>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', color: '#212121', lineHeight: 1.6 }}>•</Typography>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121' }}>{text}</Typography>
            </Box>
        ))}

        {/* Rules of Color */}
        {/* <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: '13px', color: '#212121', mt: '12px', mb: '4px' }}>
            Rules of Color :
        </Typography>
        {[
            'This is a bet for having more cards of red or Black (Heart and Diamond are named RED , Spade and Club are named BLACK ).',
            'NOTE : For side bets you can place bets on either or both the players.',
        ].map((text, i) => (
            <Box key={i} sx={{ display: 'flex', alignItems: 'flex-start', gap: '6px', mb: '2px' }}>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', color: '#212121', lineHeight: 1.6 }}>•</Typography>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121' }}>{text}</Typography>
            </Box>
        ))} */}
    </Box>
),

     'Bollywood Casino': (
        <Box>
            {/* ── Intro ── */}
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: '6px', mb: '12px' }}>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', color: '#212121', lineHeight: 1.6 }}>•</Typography>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: '12px', color: '#212121', lineHeight: 1.6 }}>
                    The bollywood table game will be played with a total of 16 cards including (J, Q, K, A) these cards and 2 deck that means game is playing with total 16*2 = 32 cards
                </Typography>
            </Box>
 
            {/* ── Card Win Sections ── */}
            {[
                {
                    cards: [{ rank: 'A', suit: '♠', color: '#212121' }],
                    winner: 'Don Wins',
                },
                {
                    cards: [
                        { rank: 'A', suit: '♥', color: '#e53935' },
                        { rank: 'A', suit: '♦', color: '#e53935' },
                        { rank: 'A', suit: '♣', color: '#212121' },
                    ],
                    winner: 'Amar Akbar Anthony Wins',
                },
                {
                    cards: [
                        { rank: 'K', suit: '♠', color: '#212121' },
                        { rank: 'Q', suit: '♠', color: '#212121' },
                        { rank: 'J', suit: '♠', color: '#212121' },
                    ],
                    winner: 'Sahib Bibi aur Ghulam Wins.',
                },
                {
                    cards: [
                        { rank: 'K', suit: '♦', color: '#e53935' },
                        { rank: 'K', suit: '♣', color: '#212121' },
                    ],
                    winner: 'Dharam Veer Wins.',
                },
                {
                    cards: [
                        { rank: 'K', suit: '♥', color: '#e53935' },
                        { rank: 'Q', suit: '♣', color: '#212121' },
                        { rank: 'Q', suit: '♦', color: '#e53935' },
                        { rank: 'Q', suit: '♥', color: '#e53935' },
                    ],
                    winner: 'Kis Kisko Pyaar Karoon Wins.',
                },
                {
                    cards: [
                        { rank: 'J', suit: '♥', color: '#e53935' },
                        { rank: 'J', suit: '♣', color: '#212121' },
                        { rank: 'J', suit: '♦', color: '#e53935' },
                    ],
                    winner: 'Ghulam Wins.',
                },
            ].map(({ cards, winner }, i) => (
                <Box key={i} sx={{ mb: '14px' }}>
                    <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '11px', color: '#666', mb: '4px' }}>
                        If the card is
                    </Typography>
                    <Box sx={{ display: 'flex', gap: '6px', mb: '4px' }}>
                        {cards.map((card, ci) => (
                            <Box
                                key={ci}
                                sx={{
                                    width: '32px', height: '42px',
                                    borderRadius: '4px',
                                    background: 'linear-gradient(144deg, #F2F2F2 2%, #D9D9D9 98%)',
                                    boxShadow: '0 1px 3px rgba(0,0,0,0.18)',
                                    border: '1px solid #ccc',
                                    display: 'flex', flexDirection: 'column',
                                    alignItems: 'center', justifyContent: 'center',
                                }}
                            >
                                <Typography sx={{ fontSize: '11px', fontWeight: 700, color: card.color, lineHeight: 1 }}>{card.rank}</Typography>
                                <Typography sx={{ fontSize: '16px', color: card.color, lineHeight: 1 }}>{card.suit}</Typography>
                            </Box>
                        ))}
                    </Box>
                    <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', color: '#212121' }}>
                        {winner}
                    </Typography>
                </Box>
            ))}
 
            {/* ── Bullet Points ── */}
            {[
                'ODD: J K A',
                'DULHA DULHAN: Q K  Payout: 1.97',
                'BARATI: A J  Payout: 1.97',
                'RED: Payout: 1.97',
                'BLACK: Payout: 1.97',
                'J, Q, K, A  PAYOUT: 3.75',
                'A = DON',
                'B = AMAR AKBAR ANTHONY',
                'C = SAHIB BIBI AUR GHULAM',
                'D = DHARAM VEER',
                'E = KIS KISKO PYAAR KAROON',
                'F = GHULAM',
            ].map((text, i) => (
                <Box key={i} sx={{ display: 'flex', alignItems: 'flex-start', gap: '6px', mb: '3px' }}>
                    <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', color: '#212121', lineHeight: 1.6 }}>•</Typography>
                    <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', color: '#212121', lineHeight: 1.6 }}>{text}</Typography>
                </Box>
            ))}
        </Box>
    ),

    'Amar Akbar Anthony': (
        <Box>
            {/* ── Who Wins ── */}
            {[
                'If the card is ACE, 2, 3, 4, 5, or 6 — Amar Wins.',
                'If the card is 7, 8, 9 or 10 — Akbar wins.',
                'If the card is J, Q or K — Anthony wins.',
            ].map((text, i) => (
                <Box key={i} sx={{ display: 'flex', alignItems: 'flex-start', gap: '6px', mb: '4px' }}>
                    <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', color: '#212121', lineHeight: 1.6 }}>•</Typography>
                    <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', color: '#212121', lineHeight: 1.6 }}>{text}</Typography>
                </Box>
            ))}

            {/* ── Payout Sections ── */}
            {[
                { label: 'EVEN',    payout: '2.12', desc: 'If the card is 2 , 4 , 6 , 8 , 10 , Q' },
                { label: 'ODD',     payout: '1.83', desc: 'If the card is A , 3 , 5 , 7 , 9 , J , K' },
                { label: 'RED',     payout: '1.97', desc: 'If the card color is DIAMOND or HEART' },
                { label: 'BLACK',   payout: '1.97', desc: 'If the card color is CLUB or SPADE' },
                { label: 'UNDER 7', payout: '2.0',  desc: 'If the card is A , 2 , 3 , 4 , 5 , 6' },
                { label: 'OVER 7',  payout: '2.0',  desc: 'If the card is 8 , 9 , 10 , J , Q , K' },
            ].map(({ label, payout, desc }) => (
                <Box key={label} sx={{ mt: '10px' }}>
                    <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontSize: '12px', lineHeight: 1.6, color: '#212121' }}>
                        <span style={{ color: '#118AB2', fontWeight: 700 }}>{label}</span>
                        <span style={{ fontWeight: 600 }}>{`(PAYOUT ${payout})`}</span>
                    </Typography>
                    <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121' }}>
                        {desc}
                    </Typography>
                </Box>
            ))}

            {/* ── Note ── */}
            <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121', mt: '10px' }}>
                <span style={{ fontWeight: 700 }}>Note: </span>
                If the card is 7,Bets on Under 7 and Over 7 will lose 50% of the bet amount
            </Typography>

            {/* ── CARDS Payout ── */}
            <Box sx={{ mt: '10px' }}>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontSize: '12px', lineHeight: 1.6, color: '#212121' }}>
                    <span style={{ color: '#118AB2', fontWeight: 700 }}>CARDS</span>
                    <span style={{ fontWeight: 600 }}>(PAYOUT 12.0)</span>
                </Typography>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121' }}>
                    A , 2 , 3 , 4 , 5 , 6 , 7 , 8 , 9 , 10 , J , Q , K
                </Typography>
            </Box>
        </Box>
    ),

    '32 Cards': (
        <Box>
            {/* ── Image 1: Cards Deck Table ── */}
            <img
                src={card32Table}
                alt="32 Cards Deck Table"
                style={{ width: '100%', marginBottom: '3px', display: 'block',height:'98px',width:'304px' }}
            />

            {/* ── Text after Image 1 ── */}
            <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121', mb: '6px' }}>
                This is a value card game & Winning result will count on Highest cards total.
            </Typography>
            <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121', mb: '10px' }}>
                There are total 4 players, every player have default prefix points. Default points will be consider as following table.
            </Typography>

            {/* ── Image 2: Player Points Table ── */}
            <img
                src={card32Rules}
                alt="32 Cards Player Points"
                style={{ width: '100%', marginBottom: '3px', display: 'block' ,height:'19px',width:'304px' }}
            />

            {/* ── Text after Image 2 ── */}
            {[
                'In game, every player has to count sum of default points and their own opened card\'s point.',
                'If in first level, the sum is same with more than one player, then that will be tie and winner tied players go for next level.',
                'This sum will go and go upto Single Player Highest Sum of Point.',
                'At last Highest Point Cards\'s Player declare as a Winner.',
              
            ].map((text, i) => (
                <Typography key={i} sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121', mb: '5px' }}>
                    {text}
                </Typography>
            ))}
        </Box>
    ),

'2 Card Teen Patti': (
    <Box>
        {/* ── Color Plus Section ── */}
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', color: '#212121', mb: '4px' }}>
            •Color Plus:
        </Typography>
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121', mb: '4px' }}>
           • It contains seven circumstances to bet on simultaneously, however you can only win prize money on the item which has the higher rate.
        </Typography>
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121', mb: '10px' }}>
           • The seven outcomes on which you can bet are listed below:
        </Typography>

        {/* ── Image 1 ── */}
        <img
            src={cardteen}
            alt="2 Card Teen Patti Rules"
            style={{ width: '304px', display: 'block', marginBottom: '10px' }}
        />

        {/* ── Text after Image 1 ── */}
        {[
            'Here you will win prize in case there is a 4 card pure sequence only…! Hence they will not receive the prize of:',
            '3 card sequence',
            '4 card sequence',
            '4 card color',
            '3 card pure sequence',
        ].map((text, i) => (
            <Box key={i} sx={{ display: 'flex', alignItems: 'flex-start', gap: '6px', mb: '4px' }}>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: i === 0 ? 700 : 600, fontSize: '12px', color: '#212121', lineHeight: 1.6 }}>
                    {i === 0 ? '' : '•'}
                </Typography>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: i === 0 ? 700 : 600, fontSize: '12px', lineHeight: 1.6, color: '#212121' }}>
                    {text}
                </Typography>
            </Box>
        ))}

        {/* ── Next Example ── */}
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: '12px', color: '#212121', mt: '10px', mb: '6px' }}>
            Next example.
        </Typography>
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121', mb: '4px' }}>
            If the cards are:
        </Typography>
        {[
            'King of Spades',
            'King of Clubs',
            'King of Diamonds',
            'King of Hearts',
        ].map((card, i) => (
            <Box key={i} sx={{ display: 'flex', alignItems: 'flex-start', gap: '6px', mb: '2px' }}>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', color: '#212121', lineHeight: 1.6 }}>•</Typography>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121' }}>{card}</Typography>
            </Box>
        ))}
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121', mt: '8px', mb: '4px' }}>
            In this instance you will only receive the prize of 4 of a kind, therefore you will not win prize of 3 of a kind.
        </Typography>
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121', mb: '10px' }}>
            You will only be able to win one prize, the one which is the most beneficial to them.
        </Typography>

        {/* ── Main Section ── */}
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: '13px', color: '#212121', mb: '6px' }}>
            Main:
        </Typography>
        {[
            'In case of consecutive cards, the third card is to be considered in ascending order only. For example,',
            'If the first two cards are king & ace then the third card is 2, so it becomes: k, A & 2 (which is not sequence).',
            'If the first two cards are 2 & 3, then third card is 4, so it becomes 2,3,4 (it will not be 1,2,3).',
            'The sequence in order from 1st to last is listed below:',
        ].map((text, i) => (
            <Typography key={i} sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121', mb: '4px' }}>
                {text}
            </Typography>
        ))}

        {/* ── Image 2 ── */}
        <img
            src={cardteen1}
            alt="2 Card Teen Patti Rules"
            style={{ width: '304px', display: 'block', marginBottom: '4px', height: '153px' }}
        />

        {/* ── Text after Image 2 ── */}
        {[
            'If it is alternative cards eg. 6 & 8. Or 2 & 4 Or Q & A',
            'This type of alternative game will not be considered as a sequence..!',
            'If it comes 4 & 4 this will be considered as a trio of 4',
            'Another example is Ace & Ace, which will be considered as trio of Ace.',
        ].map((text, i) => (
            <Box key={i} sx={{ display: 'flex', alignItems: 'flex-start', gap: '6px', mb: '4px' }}>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', color: '#212121', lineHeight: 1.6 }}>•</Typography>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121' }}>{text}</Typography>
            </Box>
        ))}

        {/* ── Best Combination ── */}
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: '13px', color: '#212121', mt: '10px', mb: '6px' }}>
           • Best combination of games in order of 1st to last:
        </Typography>
        {[
            'Trio (3 of a kind): 1st best combination',
            'Pure sequence: 2nd best combination',
            'Sequence (straight): 3rd best combination',
            'Colour (suits): 4th best combination',
        ].map((text, i) => (
            <Box key={i} sx={{ display: 'flex', alignItems: 'flex-start', gap: '6px', mb: '4px' }}>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', color: '#212121', lineHeight: 1.6 }}>•</Typography>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121' }}>{text}</Typography>
            </Box>
        ))}
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121', mt: '4px', mb: '10px' }}>
            •In case of tie, result will be declared on basis of suit rank of high card.
        </Typography>
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121', mb: '10px' }}>
           • After that, all the games will be valued of higher card.
        </Typography>

        {/* ── Mini Baccarat ── */}
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: '13px', color: '#212121', mb: '6px' }}>
            Mini Baccarat:
        </Typography>
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121', mb: '8px' }}>
            It is a comparison between the last digit of Total of both the sides. Value of cards for baccarat is:
        </Typography>
        {[
            'Ace = one point', '2 = 2 point', '3 = 3 point', '4 = 4 point',
            '5 = 5 point', '6 = 6 point', '7 = 7 point', '8 = 8 point',
            '9 = 9 point', '10 = 0 point', 'Jack = 0 point', 'Queen = 0 point', 'King = 0 point',
        ].map((text, i) => (
            <Typography key={i} sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121', mb: '2px' }}>
                {text}
            </Typography>
        ))}
        {[
            'Total of two card can be ranged between 0 to 18',
            'If total is in single digit, then the same will be considered as baccarat value',
            'If the total is of double digit, then the last digit will be considered as baccarat value. Higher value baccarat will win.',
            'If baccarat value of both the sides are equal, then both side\'s will lose their bets.',
        ].map((text, i) => (
            <Box key={i} sx={{ display: 'flex', alignItems: 'flex-start', gap: '6px', mt: '6px' }}>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', color: '#212121', lineHeight: 1.6 }}>•</Typography>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121' }}>{text}</Typography>
            </Box>
        ))}

        {/* ── Total Section ── */}
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: '13px', color: '#212121', mt: '10px', mb: '6px' }}>
            Total:
        </Typography>
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121', mb: '8px' }}>
            Session is total of 2 cards value. Value of each card:
        </Typography>
        {[
            'Ace = 1 point', '2 = 2 point', '3 = 3 point', '4 = 4 point',
            '5 = 5 point', '6 = 6 point', '7 = 7 point', '8 = 8 point',
            '9 = 9 point', '10 = 10 point', 'Jack = 11 point', 'Queen = 12 point', 'King = 13 point',
        ].map((text, i) => (
            <Typography key={i} sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121', mb: '2px' }}>
                {text}
            </Typography>
        ))}
    </Box>
),

   'Dragon Tiger Lion': (
    <Box>
        {/* ── Bullet Points ── */}
        {[
            '20-20 DTL(Dragon Tiger Lion) is a 52 playing cards game, In DTL game 3 hands are dealt: for each 3 player. The player will bets which will win.',
            'The ranking of cards is, from lowest to highest: Ace, 2, 3, 4, 5, 6, 7,8, 9, 10, Jack, Queen and King when Ace is "1" and King is "13".',
            'On same card with different suit, Winner will be declare based on below winning suit sequence.',
        ].map((text, i) => (
            <Box key={i} sx={{ display: 'flex', alignItems: 'flex-start', gap: '6px', mb: '8px' }}>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', color: '#212121', lineHeight: 1.6 }}>•</Typography>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121' }}>{text}</Typography>
            </Box>
        ))}

        {/* ── Suit Ranking Cards ── */}
        {[
            { suit: '♠', label: '1st', color: '#000' },
            { suit: '♥', label: '2nd', color: '#e53935' },
            { suit: '♣', label: '3rd', color: '#000' },
            { suit: '♦', label: '4th', color: '#e53935' },
        ].map(({ suit, label, color }) => (
            <Box key={label} sx={{ display: 'flex', alignItems: 'center', gap: '10px', mb: '8px', ml: '16px' }}>
                <Box
                    sx={{
                        width: '28px',
                        height: '39px',
                        borderRadius: '4px',
                        background: 'linear-gradient(144.15deg, #F2F2F2 2.66%, #D9D9D9 97.34%)',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                        boxShadow: '0 1px 3px rgba(0,0,0,0.15)',
                    }}
                >
                    <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#212121', lineHeight: 1 }}>1</Typography>
                    <Typography sx={{ fontSize: '18px', color, lineHeight: 1, mt: '2px' }}>{suit}</Typography>
                </Box>
                <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '13px', color: '#212121' }}>
                    {label}
                </Typography>
            </Box>
        ))}
    </Box>
),

    'One Day Dragon Tiger': (
        <Box>
            {/* ── Game Rules ── */}
            <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: '13px', color: '#212121', mb: '6px' }}>
                Game Rules
            </Typography>
            {[
                'The objective in Roulette is to predict the number on which the ball will land by placing one or more bets that cover that particular number. The wheel in European Roulette includes the numbers 1-36 plus a single 0 (zero).',
                'After betting time has expired, the ball is spun within the Roulette wheel. The ball will eventually come to rest in one of the numbered pockets within the wheel. You win if you have placed a bet that covers that particular number.',
            ].map((text, i) => (
                <Typography key={i} sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121', mb: '6px' }}>
                    {text}
                </Typography>
            ))}

            {/* ── Bet Types ── */}
            <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: '13px', color: '#212121', mt: '10px', mb: '4px' }}>
                Bet Types
            </Typography>
            <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121', mb: '6px' }}>
                You can place many different kinds of bets on the Roulette table. Bets can cover a single number or a certain range of numbers, and each type of bet has its own payout rate.
            </Typography>
            <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121', mb: '6px' }}>
                Bets made on the numbered spaces on the betting area, or on the lines between them, are called Inside Bets, while bets made on the special boxes below and to the side of the main grid of numbers are called Outside Bets.
            </Typography>

            {/* ── Inside Bets ── */}
            <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: '12px', color: '#212121', mt: '8px', mb: '4px' }}>
                INSIDE BETS:
            </Typography>
            {[
                'Straight Up — place your chip directly on any single number (including zero).',
                'Split Bet — place your chip on the line between any two numbers, either on the vertical or horizontal.',
                'Street Bet — place your chip at the end of any row of numbers. A Street Bet covers three numbers.',
                'Corner Bet — place your chip at the corner (central intersection) where four numbers meet. All four numbers are covered.',
                'Line Bet — place your chip at the end of two rows on the intersection between the two rows. A line bet covers all the numbers in both rows, a total of six numbers.',
            ].map((text, i) => (
                <Typography key={i} sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121', mb: '4px' }}>
                    {text}
                </Typography>
            ))}

            {/* ── Outside Bets ── */}
            <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: '12px', color: '#212121', mt: '8px', mb: '4px' }}>
                OUTSIDE BETS:
            </Typography>
            {[
                'Column Bet — place your chip in one of the boxes marked "2 to 1" at the end of the column that covers all 12 numbers in that column. The zero is not covered by any column bet.',
                'Dozen Bet — place your chip in one of the three boxes marked "1st 12," "2nd 12" or "3rd 12" to cover the 12 numbers alongside the box.',
                'Red/Black — place your chip in the Red or Black box to cover the 18 red or 18 black numbers. The zero is not covered by these bets.',
                'Even/Odd — place your chip in one of these boxes to cover the 18 even or 18 odd numbers. The zero is not covered by these bets.',
                '1-18/19-36 — place your chip in either of these boxes to cover the first or second set of 18 numbers. The zero is not covered by these bets.',
            ].map((text, i) => (
                <Typography key={i} sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121', mb: '4px' }}>
                    {text}
                </Typography>
            ))}

            {/* ── Number Wins ── */}
            <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: '12px', color: '#212121', mt: '8px', mb: '4px' }}>
                NUMBER WINS:
            </Typography>
            <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121', mb: '6px' }}>
                If the ball comes to rest on that number.
            </Typography>

            {/* ── Place Bets & Payouts ── */}
            <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: '13px', color: '#212121', mt: '10px', mb: '4px' }}>
                Place Bets & Payouts
            </Typography>
            {[
                'In Settings icon shows the minimum and maximum allowed bet limits at the table, which may change from time to time. Open the Bet Limits to check your current limits.',
                'In Settings icon also shows the payouts of all covers section.',
                'To participate in the game, you must have sufficient funds to cover your bets. You can see your current BALANCE on your screen.',
            ].map((text, i) => (
                <Typography key={i} sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121', mb: '4px' }}>
                    {text}
                </Typography>
            ))}

            {/* ── Place Your Bets ── */}
            <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: '13px', color: '#212121', mt: '10px', mb: '4px' }}>
                PLACE YOUR BETS
            </Typography>
            {[
                'The CHIP DISPLAY allows you to select the value of each chip you wish to bet. Only chips of denominations that can be covered by your current balance will be enabled and you can change chips amount from Set Button Values.',
                'Once you have selected a chip, place your bet by simply clicking/tapping the appropriate betting spot on the game table. Each time you click/tap the betting spot, the amount of your bet increases by the value of the selected chip or up to the maximum limit for the type of bet you have selected. Once you have bet the maximum limit, no additional funds will be accepted for that bet, and a message will appear above your bet to notify you that you have bet the maximum.',
            ].map((text, i) => (
                <Typography key={i} sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121', mb: '6px' }}>
                    {text}
                </Typography>
            ))}

            {/* ── Buttons ── */}
            {[
                { label: 'Remove', desc: 'becomes available after you have placed any bet. That removes all your bets.' },
                { label: 'Rebet', desc: 'allows you to repeat all bets from the previous game round. This button is available only before the first chip is placed.' },
                { label: 'Undo', desc: 'removes the last bet you placed.' },
                { label: 'Double', desc: 'doubles your current round bets on each click and will be enabled only after First stake placed.' },
            ].map(({ label, desc }) => (
                <Typography key={label} sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121', mb: '4px' }}>
                    <span style={{ fontWeight: 700 }}>The {label} button </span>{desc}
                </Typography>
            ))}

            {/* ── NOTE ── */}
            <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '12px', lineHeight: 1.6, color: '#212121', mt: '8px', fontStyle: 'italic' }}>
                NOTE: Please do not minimise your browser or open any other tab in your browser while betting time remains, and you have placed bets on the table. Such actions may be interpreted as leaving the game, and your bets will therefore be declined for that particular game round.
            </Typography>

            {/* ── Suit ranking (same as Dragon Tiger) ── */}
            <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: '13px', color: '#212121', mt: '12px', mb: '6px' }}>
                Suit Ranking
            </Typography>
            {[
                { suit: '♠', label: '1st – Spade',   color: '#000' },
                { suit: '♥', label: '2nd – Heart',   color: '#e53935' },
                { suit: '♣', label: '3rd – Club',    color: '#000' },
                { suit: '♦', label: '4th – Diamond', color: '#e53935' },
            ].map(({ suit, label, color }) => (
                <Box key={label} sx={{ display: 'flex', alignItems: 'center', gap: '10px', mb: '8px' }}>
                    <Box
                        sx={{
                            width: '28px',
                            height: '39px',
                            borderRadius: '4px',
                            background: 'linear-gradient(144.15deg, #F2F2F2 2.66%, #D9D9D9 97.34%)',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                            boxShadow: '0 1px 3px rgba(0,0,0,0.15)',
                        }}
                    >
                        <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#212121', lineHeight: 1 }}>A</Typography>
                        <Typography sx={{ fontSize: '18px', color, lineHeight: 1, mt: '2px' }}>{suit}</Typography>
                    </Box>
                    <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '13px', color: '#212121' }}>
                        {label}
                    </Typography>
                </Box>
            ))}
        </Box>
    ),

    'Aviator': `Aviator is a crash game. A plane takes off and a multiplier rises from 1x. Cash out before the plane flies away to win. If you don't cash out in time, your bet is lost. The longer you wait, the higher the risk and reward.`,
};